<template>
  <div class="new__custom__field__label">
    <b-modal
      v-model="showDeleteFieldModal"
      type="warn"
      title="Confirm Delete"
      @ok="removeField"
      ok-title="Yes, Delete"
    >
      <p>Are you sure you want to delete this field?</p>
    </b-modal>
    <span @click.stop="controlFieldEdit" class="exclude-outside-click">
        {{ customField.label }}
    </span>
    <span v-show="editingLabel" class="edit-label-field">
        <input @blur="updateLabel" @keypress.enter="updateLabel" v-model="customField.label" v-click-outside="outside" ref="editLabelField" type="text" class="form-control"/>
    </span>
    <a class="remove-field" @click.stop="showDeleteFieldModal = true" href="#">
        <i class="fas fa-trash"></i>
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: {
        customField: Object,
        taskCount: Number,
        deliverableId: Number
    },
    data() {
        return {
            editingLabel: false,
            showDeleteFieldModal: false
        }
    },
    methods: {
        ...mapActions(["removeCustomField", "updateFieldLabel"]),
        controlFieldEdit() {
            this.editingLabel = true
            this.$nextTick(() => {
                this.$refs.editLabelField.focus()
            })
        },
        removeField() {
            let taskFieldId = this.customField.taskFieldId
            let labelId = this.customField.label_id
            this.removeCustomField({
                taskFieldId: taskFieldId,
                taskCount: this.taskCount,
                deliverableId: this.deliverableId,
                labelId: labelId
            }).then(() => {
                
            })
        },
        outside() {
            this.editingLabel = false
        },
        updateLabel() {
            this.editingLabel = false
            this.updateFieldLabel(this.customField)
        }
    }
}
</script>

<style>

</style>